<template>
    <v-dialog :value="show" max-width="800px" @input="$emit('cancel')">
        <v-card>
            <v-card-title>{{ $t("invoicing.filters.scheduleTitle") }}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                :value="filter ? filter.transportEventFilterName : ''"
                                :label="$t('invoicing.filters.transportEventFilterName')"
                                readonly
                                dense
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                :value="filter ? filter.invoicingOptionsName : ''"
                                :label="$t('invoicing.filters.invoicingOptionsName')"
                                readonly
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="name"
                                :label="$t('invoicing.filters.scheduleName')"
                                clearable
                                dense
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="description"
                                :label="$t('invoicing.filters.scheduleDescription')"
                                clearable
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-switch
                                v-model="manualCron"
                                :label="$t('invoicing.filters.scheduleManualCron')"
                                dense
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <VueCronEditorBuefy
                                v-if="!manualCron"
                                v-model="cronExpression"
                                :visibleTabs="['minutes', 'hourly', 'daily', 'weekly', 'monthly']"
                            />
                            <v-text-field
                                v-else
                                v-model="cronExpression"
                                :label="$t('invoicing.filters.scheduleCronExpression')"
                                dense
                                placeholder="0 0 * * *"
                            />
                        </v-col>
                        <v-col cols="12">
                            <span>{{ $t("scheduler.utcNote", [utcDifference()]) }}</span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="saving">{{ $t("common.save") }}</v-btn>
                <v-btn text @click="$emit('cancel')">{{ $t("common.cancel") }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000">
            {{ snackbarText }}
            <template v-slot:action>
                <v-btn text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import VueCronEditorBuefy from "vue-cron-editor-buefy";
import ScheduleFunctions from "@/models/scheduler/ScheduleFunctions";
import TopicName from "@/models/scheduler/TopicName";

export default {
    name: "InvoiceFilterScheduleDialog",
    components: { VueCronEditorBuefy },
    props: {
        show: { type: Boolean, required: true },
        filter: { type: Object, default: null },
        invoiceType: { type: String, required: true }
    },
    data() {
        return {
            cronExpression: "0 0 * * *",
            name: "",
            description: "",
            manualCron: false,
            saving: false,
            snackbar: false,
            snackbarText: "",
            snackbarColor: ""
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.cronExpression = "0 0 * * *";
                this.name = "";
                this.description = "";
                this.manualCron = false;
            }
        }
    },
    computed: {
        scheduleName() {
            if (!this.filter) return "";
            return `${this.filter.transportEventFilterName} - ${this.filter.invoicingOptionsName}`;
        }
    },
    methods: {
        async save() {
            this.saving = true;
            try {
                const schedule = {
                    function: ScheduleFunctions.CallServiceBus,
                    name: this.name || "",
                    description: this.description || "",
                    customProperties: {
                        CronTickerCustomName: this.scheduleName
                    },
                    retries: 0,
                    retryIntervals: [],
                    cronExpression: this.cronExpression,
                    serviceBusRequestConfig: {
                        TopicName: TopicName.InvoiceRequests,
                        ServiceBusMessageAsJSON: {
                            EventFilterId: this.filter.transportEventFilterId,
                            InvoicingOptionsId: this.filter.invoicingOptionsId,
                            TenantId: this.$store.state.user.tenant,
                            InvoiceType: this.invoiceType
                        },
                        ApplicationProperties: {
                            type: "triggerInvoicesByFilter"
                        }
                    },
                    tenantId: ""
                };
                await this.$store.dispatch("cronScheduler/createSchedule", schedule);
                this.snackbarText = this.$t("invoicing.filters.scheduleCreated");
                this.snackbarColor = "success";
                this.snackbar = true;
                setTimeout(() => this.$emit("created"), 1500);
            } catch (error) {
                this.snackbarText = error.message || String(error);
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                this.saving = false;
            }
        },
        utcDifference() {
            const offsetMinutes = new Date().getTimezoneOffset();
            const offsetHours = -offsetMinutes / 60;
            return offsetHours > 0 ? "+" + offsetHours : String(offsetHours);
        }
    }
};
</script>
